import { doGet, doPut, doPost, doDelete } from './common';

const getEntityColumnInfo = (key) => {
  return doGet(`/api/entity/${key}/info/column`).then(
    res => res.data.filter(x => x.comment !== undefined))
    .catch(err => {

    }).finally(() => {

    });
}

const getEntityTableInfo = (key) => {
  return doGet(`/api/entity/${key}/info/table`).then(
    res => res.data.comment)
    .catch(err => {

    }).finally(() => {

    });
}

const getList = (key) => {
  return doGet(`/api/entity/${key}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getListEnabled = (key) => {
  return doGet(`/api/entity/${key}`).then(res => (res.data.filter(x => x.enabled === true)))
    .catch(err => { })
    .finally(() => {

    });
}

const getById = (key, id) => {
  return doGet(`/api/entity/${key}/${id}`)
    .catch(err => { })
    .finally(() => {

    });
}

const insert = (key, params) => {
  return doPost(`/api/entity/${key}`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const updateById = (key, id, params) => {
  return doPut(`/api/entity/${key}/${id}`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}
const deleteById = (key, id) => {
  return doDelete(`/api/entity/${key}/${id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}
export {
  getEntityColumnInfo,
  getEntityTableInfo,
  getList,
  getListEnabled,
  getById,
  updateById,
  insert,
  deleteById,
}